import styled from 'styled-components';


const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	max-width: 100%;

	& .highcharts-axis-labels {
		z-index: -1;
	}
`;

export {
	Root,
};
